import React , { useEffect } from 'react';
import { gsap } from 'gsap';

function Home() {
    useEffect(() => {
        gsap.from('.chica', {
            duration: 1,
            x: -700,
        })
        gsap.from('.chica-dos', {
            duration: 1,
            x: 700,
        })
        gsap.from('.chico', {
            duration: 1,
            x: 700,
        })
        
    }, []);

    return (
        <React.Fragment>

            <section id="home" className="home">
                <div className='chica'></div>
                <div className='chica-dos'></div>
                <div className='chico'></div>
                <h1>Anime Sticker</h1>
                <div className='menu'>

                    <a href='#home'>

                        <div className='button'>Home</div>
                    </a>
                    <a href='#dragon-ball'>
                        <div className='button'>Dragon Ball</div>

                    </a>
                    <a href='#one-piece'>
                        <div className='button'>One Piece</div>

                    </a>
                    <a href='#bleach'>

                        <div className='button'>Bleach</div>
                    </a>
                    <a href='#naruto'>

                        <div className='button'>Naruto</div>
                    </a>
                    <a href='#pokemon'>
                        <div className='button'>Pokemon</div>

                    </a>
                </div>

            </section>

            <section id="dragon-ball" className='dragon-ball'>
                <div className='dragon-ball-logo'></div>
                <div className='list'>

                    <div className='stickers goku'></div>
                    <div className='stickers vegueta'></div>
                    <div className='stickers gohan'></div>
                    <div className='stickers piccolo'></div>
                    <div className='stickers trunks'></div>
                    <div className='stickers freezer'></div>
                    <div className='stickers cell'></div>
                    <div className='stickers crilin'></div>

                </div>
            </section>

            <section id="one-piece" className='one-piece'>
                <div className='one-piece-logo'></div>
                <div className='list'>

                    <div className='stickers luffy'></div>
                    <div className='stickers zoro'></div>
                    <div className='stickers nami'></div>
                    <div className='stickers sanji'></div>
                    <div className='stickers usop'></div>
                    <div className='stickers franklin'></div>
                    <div className='stickers chopper'></div>
                    <div className='stickers nico'></div>

                </div>
            </section>

            <section id="bleach" className='bleach'>
                <div className='bleach-logo'></div>
                <div className='list'>

                    <div className='stickers ichigo'></div>
                    <div className='stickers rukia'></div>
                    <div className='stickers orihime'></div>
                    <div className='stickers urahara'></div>
                    <div className='stickers uryu'></div>
                    <div className='stickers byakuya'></div>
                    <div className='stickers aizen'></div>
                    <div className='stickers kenpachi'></div>

                </div>
            </section>

            <section id="naruto" className='naruto'>
                <div className='naruto-logo'></div>
                <div className='list'>

                    <div className='stickers narutopj'></div>
                    <div className='stickers sasuke'></div>
                    <div className='stickers sakura'></div>
                    <div className='stickers kakashi'></div>
                    <div className='stickers orochimaru'></div>
                    <div className='stickers tsunade'></div>
                    <div className='stickers jiraiya'></div>
                    <div className='stickers cuarto'></div>

                </div>
            </section>

            <section id="pokemon" className='pokemon'>
                <div className='pokemon-logo'></div>
                <div className='list'>

                    <div className='stickers pikachu'></div>
                    <div className='stickers borbarsor'></div>
                    <div className='stickers charmander'></div>
                    <div className='stickers escuero'></div>
                    <div className='stickers hoho'></div>
                    <div className='stickers pichoto'></div>
                    <div className='stickers haunter'></div>
                    <div className='stickers butterfree'></div>

                </div>
            </section>



        </React.Fragment>
    );


}
export default Home;